import { seriesSvgMulti } from '@d3fc/d3fc-series';

import { CandlestickTileDataTimeSeriesItem } from 'widgets/candlestickTile/candlestickTileData';
import { timeSeriesCandlestick } from 'utils/components/TimeSeriesChart/candlestick';

export const candlestickSeries =
    timeSeriesCandlestick<CandlestickTileDataTimeSeriesItem>(
        (d) => d.open,
        (d) => d.high,
        (d) => d.low,
        (d) => d.close,
        'candlestick'
    );

export const candlestickTilesSeries = seriesSvgMulti().series([
    candlestickSeries,
]);
